<template>
	<div id="app" @click="all()">
		<div class="main">

			<div class="app-content" v-if="user.logged" id="app-content">
				<pane-header />				
				<pane-programs v-show="(app.view == 'neuf') || (app.view == '')" />
				<pane-program v-show="app.viewprog == 'program'" />
				<pane-rss v-show="app.view == 'rss'" />
				<pane-rs v-show="app.viewprog == 'rs'" />
				<pane-rplss v-show="app.view == 'rpls'" />
				<pane-gisements v-show="app.view == 'gisements'" />
				<pane-fil v-show="app.view == 'fil'" />
				<pane-gisement v-show="app.viewprog == 'gisement'" />
				<pane-rpls v-show="app.viewprog == 'rpls'" />
				<pane-offre v-show="app.viewprog == 'offre'" />
				<pane-offre-locatif v-show="app.viewprog == 'offre-locatif'" />
				<pane-annonce v-show="app.viewprog == 'annonce'" />
				<pane-module v-show="app.view != 'home'" />
				<pane-user v-show="app.view == 'user'" />
				<pane-cdc v-show="app.view == 'etudecdc'" />
				<pane-map v-show="app.view != 'user' && app.view != 'etudecdc'" />
				<pane-report v-show="app.view != 'user' && app.view != 'etudecdc'"/>
				<pane-report-vm v-show="app.view != 'user' && app.view != 'etudecdc'"/>
				<pane-report-adeq v-show="app.view != 'user' && app.view != 'etudecdc'"/>
				<pane-report-B v-show="app.view != 'user' && app.view != 'etudecdc'"/>
				<pane-report-E v-show="app.view != 'user' && app.view != 'etudecdc'"/>
				<pane-compte v-show="app.view == 'compte'"  />
				<pane-home v-show="app.view == 'home'" />

        <pane-adresse v-show="app.view == 'adresse'" />

        <pane-adresse-vie v-show="app.view == 'vie'" />

        <pane-adresse-transport v-show="app.view == 'transport'" />
				<pane-adresse-transport-bus v-show="app.view == 'transport-bus'" />
				<pane-adresse-transport-tram v-show="app.view == 'transport-tram'" />
				<pane-adresse-transport-metro v-show="app.view == 'transport-metro'" />
				<pane-adresse-transport-route-rapide v-show="app.view == 'transport-route-rapide'" />
				<pane-adresse-transport-parking v-show="app.view == 'transport-parking'" />
				<pane-adresse-transport-gare v-show="app.view == 'transport-gare'" />
				<pane-adresse-transport-aeroport v-show="app.view == 'transport-aeroport'" />
				<pane-adresse-transport-port v-show="app.view == 'transport-port'" />
				<pane-adresse-transport-velo v-show="app.view == 'transport-velo'" />
				<pane-adresse-transport-auto v-show="app.view == 'transport-auto'" />
				<pane-adresse-transport-borne v-show="app.view == 'transport-borne'" />

				<pane-adresse-ecole v-show="app.view == 'education'" />
				<pane-adresse-education-creche v-show="app.view == 'education-creche'" />
				<pane-adresse-education-maternelle v-show="app.view == 'education-maternelle'" />
				<pane-adresse-education-elementaire v-show="app.view == 'education-elementaire'" />
				<pane-adresse-education-college v-show="app.view == 'education-college'" />
				<pane-adresse-education-lycee v-show="app.view == 'education-lycee'" />
				<pane-adresse-education-lycee-pro v-show="app.view == 'education-lycee-pro'" />
				<pane-adresse-education-universite v-show="app.view == 'education-universite'" />
				<pane-adresse-education-superieur v-show="app.view == 'education-superieur'" />
				<pane-adresse-education-formation v-show="app.view == 'education-formation'" />

				<pane-adresse-commerces v-show="app.view == 'commerces'" />
				<pane-adresse-commerce-alimentation v-show="app.view == 'commerce-alimentation'" />
				<pane-adresse-commerce-bouche v-show="app.view == 'commerce-bouche'" />
				<pane-adresse-commerce-utilitaire v-show="app.view == 'commerce-utilitaire'" />
				<pane-adresse-commerce-shopping v-show="app.view == 'commerce-shopping'" />
				<pane-adresse-commerce-soin v-show="app.view == 'commerce-soin'" />
				<pane-adresse-commerce-logement v-show="app.view == 'commerce-logement'" />
				<pane-adresse-commerce-vehicule v-show="app.view == 'commerce-vehicule'" />

				<pane-adresse-loisirs v-show="app.view == 'loisirs'" />
				<pane-adresse-loisir-bibliotheque v-show="app.view == 'loisir-bibliotheque'" />
				<pane-adresse-loisir-theatre v-show="app.view == 'loisir-theatre'" />
				<pane-adresse-loisir-musee v-show="app.view == 'loisir-musee'" />
				<pane-adresse-loisir-cinema v-show="app.view == 'loisir-cinema'" />
				<pane-adresse-loisir-bar v-show="app.view == 'loisir-bar'" />
				<pane-adresse-loisir-restaurant v-show="app.view == 'loisir-restaurant'" />
				<pane-adresse-loisir-discotheque v-show="app.view == 'loisir-discotheque'" />
				<pane-adresse-loisir-jardin v-show="app.view == 'loisir-jardin'" />
				<pane-adresse-loisir-sport-collectif v-show="app.view == 'loisir-sport-collectif'" />
				<pane-adresse-loisir-sport-individuel v-show="app.view == 'loisir-sport-individuel'" />
				<pane-adresse-loisir-hotel v-show="app.view == 'loisir-hotel'" />
				<pane-adresse-loisir-hebergement v-show="app.view == 'loisir-hebergement'" />

				<pane-adresse-services v-show="app.view == 'services'" />
				<pane-adresse-service-agees v-show="app.view == 'service-agees'" />
				<pane-adresse-service-commissariat v-show="app.view == 'service-commissariat'" />
				<pane-adresse-service-dechet v-show="app.view == 'service-dechet'" />
				<pane-adresse-service-gendarmerie v-show="app.view == 'service-gendarmerie'" />
				<pane-adresse-service-hopital v-show="app.view == 'service-hopital'" />
				<pane-adresse-service-laboratoire v-show="app.view == 'service-laboratoire'" />
				<pane-adresse-service-medecin v-show="app.view == 'service-medecin'" />
				<pane-adresse-service-pharmacie v-show="app.view == 'service-pharmacie'" />
				<pane-adresse-service-pompier v-show="app.view == 'service-pompier'" />
				<pane-adresse-service-poste v-show="app.view == 'service-poste'" />
				<pane-adresse-service-recyclage v-show="app.view == 'service-recyclage'" />
				<pane-adresse-service-specialiste v-show="app.view == 'service-specialiste'" />

				<pane-adresse-numerique v-show="app.view == 'numerique'" />
				<pane-ancien-mutations v-show="app.view == 'ancien-mutations'" />
				<pane-ancien-offres v-show="app.view == 'ancien-offre'" />
				<pane-locatif-offres v-show="app.view == 'locatif-offre'" />
				<pane-ancien-conjoncture v-show="app.view == 'ancien-conjoncture'" />
				<pane-locatif-conjoncture v-show="app.view == 'locatif-conjoncture'" />
				<pane-ancien v-show="app.view == 'ancien'" />
				<pane-ancien-adeq v-show="app.view == 'ancien-adeq'" />
				<pane-locatif-adeq v-show="app.view == 'locatif-adeq'" />
				<pane-locatif v-show="app.view == 'locatif'" />
				<pane-carto-locatif v-show="app.view == 'carto-locatif'" />
				<pane-adresse-icones v-show="app.view == 'icones'" />

				<pane-layer />
				<pane-legende />
				<pane-insee />
				<pane-isochrone />
				<pane-aide />
				<pane-ancien-locatifs v-show="app.view == 'ancien-locatif'" />
				<pane-biens-locatifs />
				<pane-filters-promotion/>
				<!--
				// Gestion préférences
				<pane-preferences-promotion/>
				-->
				<pane-filters-rs/>
				<pane-filters-rpls/>
				<pane-filters-ancien/>
				<pane-aide-programme />
				<pane-aide-live />
				<pane-footer v-show="app.view == 'home' || app.view == 'user'"/>
			</div>

			<div class="login-content" v-if="!user.logged">
				<login />
			</div>

		</div>
		
		<transition-group name="notifications" class="notifications" tag="div">
			<notification 	v-for="notification in app.notifications" :key="notification.id" :notification="notification" />
		</transition-group>
		<transition-group name="notificationone" class="notificationone" tag="div">
			<notificationone v-for="notificationone in app.notificationone" :key="notificationone.id" :notificationone="notificationone" />
		</transition-group>
		<Toast position="top-right" />
		<!--
		<Dialog header="Documents d'urbanisme" :visible.sync="app.DialogMessageDocuments" :containerStyle="{width: '50vw'}">
			<p class="m-0" v-for="d in uniqueDocumentsUrbanisme" :key="'doc_' + d.properties.cle_naturelle">
				<a target="_blank" :href="d.properties.url">{{ d.properties.description }}</a>
			</p>
			<template #footer>
				<Button :label="$t('Fermer')" icon="pi pi-times" @click="openPLU(false)" class="p-button-text"/>
			</template>
		</Dialog>
		-->
		<Dialog header="Préparation des données pour la génération du rapport" :visible.sync="app.export_progress_visible" :containerStyle="{width: '50vw'}" modal>
			<div v-if="app.export_progress_visible" class="export-progress-wrapper">
				<div class="progress-bar">
				<div class="progress-bar-fill" :style="{ width: export_progress + '%' }"></div>
				</div>
				<p>{{ Math.floor(export_progress) }} % effectué</p>
			</div>
		</Dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Bus } from './Bus'
import VueJwtDecode from 'vue-jwt-decode'
import Login from './components/Login'
import PaneHome from './components/PaneHome'
import PanePrograms from './components/PanePrograms'
import PaneGisements from './components/PaneGisements'
import PaneFil from './components/PaneFil'
import PaneProgram from './components/PaneProgram'
import PaneRplss from './components/PaneRplss'
import PaneRpls from './components/PaneRpls'
import PaneGisement from './components/PaneGisement'
import PaneOffre from './components/PaneOffre'
import PaneOffreLocatif from './components/PaneOffreLocatif'
import PaneAnnonce from './components/PaneAnnonce'
import PaneRss from './components/PaneRss'
import PaneRs from './components/PaneRs'
import PaneUser from './components/PaneUser'
import PaneCdc from './components/PaneCdc'
import PaneMap from './components/PaneMap'
import PaneReport from './components/PaneReport'
import PaneReportVm from './components/PaneReportVm'
import PaneReportAdeq from './components/PaneReportAdeq'
import PaneReportB from './components/PaneReportB'
import PaneReportE from './components/PaneReportE'
import PaneCompte from './components/PaneCompte'
import Notification from './components/global/Notification'
import Notificationone from './components/global/Notificationone'
import PaneModule from './components/PaneModule'
import PaneAdresse from './components/pane-adresse/PaneAdresse'
import PaneAdresseVie from './components/pane-adresse/PaneAdresseVie'
import PaneAdresseTransport from './components/pane-adresse/PaneAdresseTransport'
import PaneAdresseTransportBus from './components/pane-adresse/PaneAdresseTransportBus'
import PaneAdresseTransportTram from './components/pane-adresse/PaneAdresseTransportTram'
import PaneAdresseTransportMetro from './components/pane-adresse/PaneAdresseTransportMetro'
import PaneAdresseTransportRouteRapide from './components/pane-adresse/PaneAdresseTransportRouteRapide'
import PaneAdresseTransportParking from './components/pane-adresse/PaneAdresseTransportParking'
import PaneAdresseTransportGare from './components/pane-adresse/PaneAdresseTransportGare'
import PaneAdresseTransportAeroport from './components/pane-adresse/PaneAdresseTransportAeroport'
import PaneAdresseTransportPort from './components/pane-adresse/PaneAdresseTransportPort'
import PaneAdresseTransportVelo from './components/pane-adresse/PaneAdresseTransportVelo'
import PaneAdresseTransportAuto from './components/pane-adresse/PaneAdresseTransportAuto'
import PaneAdresseTransportBorne from './components/pane-adresse/PaneAdresseTransportBorne'
import PaneAdresseEcole from './components/pane-adresse/PaneAdresseEcole'
import PaneAdresseEducationCreche from './components/pane-adresse/PaneAdresseEducationCreche'
import PaneAdresseEducationMaternelle from './components/pane-adresse/PaneAdresseEducationMaternelle'
import PaneAdresseEducationElementaire from './components/pane-adresse/PaneAdresseEducationElementaire'
import PaneAdresseEducationCollege from './components/pane-adresse/PaneAdresseEducationCollege'
import PaneAdresseEducationLycee from './components/pane-adresse/PaneAdresseEducationLycee'
import PaneAdresseEducationLyceePro from './components/pane-adresse/PaneAdresseEducationLyceePro'
import PaneAdresseEducationUniversite from './components/pane-adresse/PaneAdresseEducationUniversite'
import PaneAdresseEducationSuperieur from './components/pane-adresse/PaneAdresseEducationSuperieur'
import PaneAdresseEducationFormation from './components/pane-adresse/PaneAdresseEducationFormation'
import PaneAdresseCommerces from './components/pane-adresse/PaneAdresseCommerces'
import PaneAdresseCommerceAlimentation from './components/pane-adresse/PaneAdresseCommerceAlimentation.vue'
import PaneAdresseCommerceBouche from './components/pane-adresse/PaneAdresseCommerceBouche.vue'
import PaneAdresseCommerceUtilitaire from './components/pane-adresse/PaneAdresseCommerceUtilitaire.vue'
import PaneAdresseCommerceShopping from './components/pane-adresse/PaneAdresseCommerceShopping.vue'
import PaneAdresseCommerceSoin from './components/pane-adresse/PaneAdresseCommerceSoin.vue'
import PaneAdresseCommerceLogement from './components/pane-adresse/PaneAdresseCommerceLogement.vue'
import PaneAdresseCommerceVehicule from './components/pane-adresse/PaneAdresseCommerceVehicule.vue'
import PaneAdresseNumerique from './components/pane-adresse/PaneAdresseNumerique'
import PaneAncien from './components/pane-adresse/PaneAncien'
import PaneAncienAdeq from './components/pane-adresse/PaneAncienAdeq'
import PaneLocatifAdeq from './components/pane-adresse/PaneLocatifAdeq'
import PaneLocatif from './components/pane-adresse/PaneLocatif'
import PaneAdresseLoisirs from './components/pane-adresse/PaneAdresseLoisirs'
import PaneAdresseLoisirBibliotheque from './components/pane-adresse/PaneAdresseLoisirBibliotheque.vue'
import PaneAdresseLoisirTheatre from './components/pane-adresse/PaneAdresseLoisirTheatre.vue'
import PaneAdresseLoisirMusee from './components/pane-adresse/PaneAdresseLoisirMusee.vue'
import PaneAdresseLoisirCinema from './components/pane-adresse/PaneAdresseLoisirCinema.vue'
import PaneAdresseLoisirBar from './components/pane-adresse/PaneAdresseLoisirBar.vue'
import PaneAdresseLoisirRestaurant from './components/pane-adresse/PaneAdresseLoisirRestaurant.vue'
import PaneAdresseLoisirDiscotheque from './components/pane-adresse/PaneAdresseLoisirDiscotheque.vue'
import PaneAdresseLoisirJardin from './components/pane-adresse/PaneAdresseLoisirJardin.vue'
import PaneAdresseLoisirSportCollectif from './components/pane-adresse/PaneAdresseLoisirSportCollectif.vue'
import PaneAdresseLoisirSportIndividuel from './components/pane-adresse/PaneAdresseLoisirSportIndividuel.vue'
import PaneAdresseLoisirHotel from './components/pane-adresse/PaneAdresseLoisirHotel.vue'
import PaneAdresseLoisirHebergement from './components/pane-adresse/PaneAdresseLoisirHebergement.vue'
import PaneAdresseServices from './components/pane-adresse/PaneAdresseServices'
import PaneAdresseServiceAgees from './components/pane-adresse/PaneAdresseServiceAgees.vue'
import PaneAdresseServiceCommissariat from './components/pane-adresse/PaneAdresseServiceCommissariat.vue'
import PaneAdresseServiceHopital from './components/pane-adresse/PaneAdresseServiceHopital.vue'
import PaneAdresseServiceLaboratoire from './components/pane-adresse/PaneAdresseServiceLaboratoire.vue'
import PaneAdresseServiceMedecin from './components/pane-adresse/PaneAdresseServiceMedecin.vue'
import PaneAdresseServicePharmacie from './components/pane-adresse/PaneAdresseServicePharmacie.vue'
import PaneAdresseServiceRecyclage from './components/pane-adresse/PaneAdresseServiceRecyclage.vue'
import PaneAdresseServiceDechet from './components/pane-adresse/PaneAdresseServiceDechet.vue'
import PaneAdresseServiceGendarmerie from './components/pane-adresse/PaneAdresseServiceGendarmerie.vue'
import PaneAdresseServicePompier from './components/pane-adresse/PaneAdresseServicePompier.vue'
import PaneAdresseServicePoste from './components/pane-adresse/PaneAdresseServicePoste.vue'
import PaneAdresseServiceSpecialiste from './components/pane-adresse/PaneAdresseServiceSpecialiste.vue'
import PaneHeader from './components/PaneHeader'
import PaneFooter from './components/PaneFooter'
import PaneAdresseIcones from './components/pane-adresse/PaneAdresseIcones.vue'
import PaneAncienMutations from './components/pane-adresse/PaneAncienMutations.vue'
import PaneAncienOffres from './components/pane-adresse/PaneAncienOffres.vue'
import PaneLocatifOffres from './components/pane-adresse/PaneLocatifOffres.vue'
import PaneAncienLocatifs from './components/pane-adresse/PaneAncienLocatifs.vue'
import PaneCartoLocatif from './components/PaneCartoLocatif.vue'
import PaneAncienConjoncture from './components/pane-adresse/PaneAncienConjoncture.vue'
import PaneLayer from './components/PaneLayer.vue'
import PaneLegende from './components/PaneLegende.vue'
import PaneInsee from './components/PaneInsee.vue'
import PaneIsochrone from './components/PaneIsochrone.vue'
import PaneLocatifConjoncture from './components/pane-adresse/PaneLocatifConjoncture.vue'
import PaneAide from './components/PaneAide.vue'
import PaneAideProgramme from './components/PaneAideProgramme.vue'
import PaneAideLive from './components/PaneAideLive.vue'
import PaneFiltersPromotion from './components/PaneFiltersPromotion.vue'
import PanePreferencesPromotion from './components/PanePreferencesPromotion.vue'
import PaneFiltersRs from './components/PaneFiltersRs.vue'
import PaneFiltersRpls from './components/PaneFiltersRpls.vue'
import PaneFiltersAncien from './components/PaneFiltersAncien.vue'
import PaneBiensLocatifs from './components/PaneBiensLocatifs.vue'
import Toast from 'primevue/toast';
import '@fontsource/nunito'; // Défaut : inclut les poids 400
import Dialog from 'primevue/dialog';

export default {
	name: 'App',
	computed: Object.assign(mapGetters([ 'app', 'user' ]), {
		export_progress: function() {
			return this.app.export_progress
		},
		uniqueDocumentsUrbanisme() {
			const seen = new Set();
			if (this.app.parcelle_zone_urbaine) {
				return this.app.parcelle_zone_urbaine.filter(d => {
					if (!d.properties?.url) return false;
					if (seen.has(d.properties.url)) return false;
					seen.add(d.properties.url);
					return true;
					});
				}
			return seen
		}
	}),
	watch: {
		'app.viewprog': function(newValue) {
			if (document.getElementById('zohohc-asap-web-launcherbox') != null) {
				if (newValue=='program') {
					document.getElementById('zohohc-asap-web-launcherbox').style.visibility = 'hidden'
				} else {
					document.getElementById('zohohc-asap-web-launcherbox').style.visibility = 'visible'
				}
			}
		},
	},
	methods: {
        openPLU(b) {
			this.$store.commit('SET_VALUE', {c: 'DialogMessageDocuments', v: b});
        },
		
		all: function() {
			Bus.$emit('global-click');
		},
		getUserDetails: function() {
			let that = this
			let token = localStorage.getItem("user");
			let da = new Date();
			let d = da.toISOString().substring(0, 10);
			try {
				let decoded = VueJwtDecode.decode(token);
				if (d != decoded.emission.substring(0, 10)){
					token = false
				}
			} catch (error) {
				token = false
			}

			if (token) {
				that.$store.dispatch('set_autolog', {autolog: true})
				try {
					//decode token here and attach to the user object
					that.$store.dispatch('loginbytoken', { token: token, callback: function() {
						// Après connexion, on charge le contenu en fonction de la route (load_by_route)
						that.$store.dispatch('set_view', {view: 'home'})
						that.$store.dispatch('set_autolog', {autolog: false})
					} })			
				} catch (error) {
					console.log(error, 'error from decoding token')
					that.$store.dispatch('set_autolog', {autolog: false})
				}
			} else {
				// Nothing
			}
		},

		init: function() {
			let that = this

			// S'il existe un token de connexion dans le localStorage on l'utilise pour se reconnecter automatiquement
			let EFOCUSPPFLOG = VueCookies.get('EFOCUSPPFLOG')
			if (EFOCUSPPFLOG) {
				let sid = EFOCUSPPFLOG.split('###')[1]
				let smdp = EFOCUSPPFLOG.split('###')[0]
				that.$store.dispatch('login', { email: sid, password: smdp, callback: function() {
					// Après connexion, on charge le contenu en fonction de la route (load_by_route)
					that.$store.dispatch('set_view', {view: 'home'})
				} })
			}
		},
		handleScroll() {
			const sections = document.querySelectorAll('.section'); // Sélectionnez toutes les sections
			// Parcourez les sections pour trouver celle qui est actuellement visible
			sections.forEach(section => {
				const rect = section.getBoundingClientRect();
				if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
					this.activeSection = section.id; // Mettez à jour la section active
				}
			});
		},

		loadGoogleMaps() {
			const script = document.createElement('script');
			script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}&callback=Function.prototype&solution_channel=GMP_QB_addressselection_v1_cAB`;
			script.async = true;
			script.defer = true;
			document.head.appendChild(script);
		},		
	},


	mounted: function() {
		let that = this

		// Appelle de la fonction d'initialisation plus haut pour gérer le login puis on charge le contenu en fonction de la route (load_by_route)
		that.getUserDetails()
	},
// eslint-disable-next-line
	components: { Dialog, Toast, PaneCartoLocatif, Login, PaneHome, PanePrograms, PaneGisements, PaneFil, PaneGisement, PaneMap, PaneReport, PaneReportVm, PaneReportAdeq, PaneReportB, PaneReportE, PaneUser, PaneCdc, PaneCompte, Notification, Notificationone, PaneFooter, PaneHeader, PaneProgram, PaneModule, PaneAdresse, PaneAdresseVie, PaneAdresseTransport, PaneAdresseEcole, PaneAdresseNumerique, PaneAncienAdeq, PaneLocatifAdeq, PaneAncien, PaneLocatif, PaneAdresseServices, PaneAdresseCommerces, PaneAdresseLoisirs, PaneAdresseTransportBus, PaneAdresseTransportTram, PaneAdresseTransportMetro, PaneAdresseTransportParking, PaneAdresseTransportGare, PaneAdresseTransportAeroport, PaneAdresseTransportPort, PaneAdresseTransportVelo, PaneAdresseTransportAuto, PaneAdresseTransportBorne, PaneAdresseTransportRouteRapide, PaneAdresseEducationCreche, PaneAdresseEducationMaternelle, PaneAdresseEducationElementaire, PaneAdresseEducationCollege, PaneAdresseEducationLycee, PaneAdresseEducationLyceePro, PaneAdresseEducationUniversite, PaneAdresseEducationSuperieur, PaneAdresseEducationFormation, PaneAdresseCommerceAlimentation, PaneAdresseCommerceBouche, PaneAdresseCommerceUtilitaire, PaneAdresseCommerceShopping, PaneAdresseCommerceSoin, PaneAdresseCommerceLogement, PaneAdresseCommerceVehicule, PaneAdresseLoisirBibliotheque, PaneAdresseLoisirTheatre, PaneAdresseLoisirMusee, PaneAdresseLoisirCinema, PaneAdresseLoisirBar, PaneAdresseLoisirRestaurant, PaneAdresseLoisirDiscotheque, PaneAdresseLoisirJardin, PaneAdresseLoisirSportCollectif, PaneAdresseLoisirSportIndividuel, PaneAdresseLoisirHotel, PaneAdresseLoisirHebergement, PaneAdresseServiceAgees, PaneAdresseServiceCommissariat, PaneAdresseServiceHopital, PaneAdresseServiceLaboratoire, PaneAdresseServiceMedecin, PaneAdresseServicePharmacie, PaneAdresseServiceRecyclage, PaneAdresseServiceDechet, PaneAdresseServiceGendarmerie, PaneAdresseServicePompier, PaneAdresseServicePoste, PaneAdresseServiceSpecialiste, PaneAdresseIcones, PaneAncienMutations, PaneAncienOffres, PaneLocatifOffres, PaneAncienConjoncture, PaneLayer,PaneLegende, PaneInsee, PaneIsochrone, PaneLocatifConjoncture, PaneAide, PaneAideProgramme, PaneAideLive, PaneFiltersPromotion, PanePreferencesPromotion, PaneFiltersRs, PaneFiltersRpls, PaneFiltersAncien, PaneBiensLocatifs, PaneRss, PaneRs, PaneRplss, PaneRpls, PaneOffre, PaneOffreLocatif, PaneAncienLocatifs, PaneAnnonce }
}
</script>


<style>
@font-face
{
  font-family: "cityscan-icon";
  src: local("cityscan-icon"),
   url(./assets/fonts/cityscan-icon.ttf) format("truetype");
}
@font-face {
  font-family: "cs-iconfont-thematic-custom";
  src: local("cs-iconfont-thematic-custom"),
   url(./assets/fonts/thematic-icon.ttf) format("truetype");
}
</style>




<style lang="stylus">
@import url('https://fonts.googleapis.com/css?family=Montserrat:400,500,600|Nunito:400,600');
@import './assets/css/app';
@import './assets/css/scrollbar.css';
@import './assets/css/index.css';

*
	margin 0
	padding 0
	position relative
	box-sizing border-box
	
html, body, #app, .main, .login-content, .app-content
	height 100%

a
	text-decoration none
	&:link
		text-decoration none
		color #536c78
	&:visited
		text-decoration none
    color #536c78
	&:focus
		text-decoration none
	&:hover
		text-decoration none
	&:active
		text-decoration none

body
	background #FFF
	font-family roboto, sans-serif
	font-size 14px
	font-weight 400
img
	vertical-align middle

.main
	overflow hidden

.attente
	bottom 25px
	right 25px
	width 300px
	height 300px
	position absolute
	box-sizing border-box
	.infinite-loader
		z-index 9999
		position absolute
		right calc(50% - 64px)
		top calc(50% - 64px)
		.loader
			display inline-block
			background main_color
			border-radius 100%
			color #333
			.icon
				display block
				animation rotate 1.5s infinite linear


.notifications
	position fixed
	right 16px
	top 16px
	z-index 5000

.notificationone
	position fixed
	right 16px
	top 16px
	z-index 5000

.notifications-enter, .notifications-leave-to
	opacity 0
	transform translateX(100%)
.notifications-leave-active
	position absolute
	
.notificationone-enter, .notificationone-leave-to
	opacity 0
	transform translateX(100%)
.notificationone-leave-active
	position absolute


.zsiq_theme1
	&.zsiq_floatmain
		z-index: 400 !important

.siq_bR
	bottom 45px !important
	right 10px

.siqembed
	&.zls-sptwndw
		right 15px
		bottom 45px !important

.export-progress-wrapper {
  margin-top: 1rem;
  padding: 0.5rem;
}

.progress-bar {
  width: 100%;
  height: 10px;
  background: #e5e7eb; /* gray-200 */
  border-radius: 5px;
  overflow: hidden;
}

.progress-bar-fill {
  height: 100%;
  background: #3b82f6; /* blue-500 */
  transition: width 0.3s ease-in-out;
}

#zohohc-asap-web-header
	position static !important

#zohohc-asap-web-launcherbox
	bottom 60px
	

@keyframes rotate
	from
		transform rotate(0deg)
	to
		transform rotate(359deg)

</style>
